var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparklineGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 20,
    viewBox: "0 0 46 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.9057L3.2449 17.3019L6.38776 19L8.18367 13.9057H12.2245L15.3673 6.09434L18.0612 8.81132L20.3061 4.39623L22.551 6.09434L27.9388 4.39623L32.4286 8.81132L35.1224 6.09434L37.8163 8.81132L39.6122 4.39623L45 1",
    stroke: "#30BB70",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklineGreen);
export default __webpack_public_path__ + "static/media/sparkline-green.bcfb03a498a4c4b0247018cadc7a987f.svg";
export { ForwardRef as ReactComponent };